var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevelUpAlt90(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "0 0 7 7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90706821,1.43381803 L3.6613975,0.0918518424 C3.54775278,-0.0305274029 3.35375999,-0.0307071257 3.23995951,0.0918518424 L1.99418097,1.43381803 C1.8239715,1.61713528 1.95373136,1.91704471 2.20489996,1.91704471 L2.97141771,1.91704471 L2.97141771,5.17601815 L1.96525758,5.17601815 C1.92712486,5.17601467 1.89055367,5.19116467 1.86359439,5.21813319 L1.19262927,5.88909831 C1.10204897,5.97966662 1.16619803,6.13453975 1.29429246,6.13453975 L3.64238283,6.13453975 C3.80119787,6.13453975 3.92993931,6.00579832 3.92993931,5.84698327 L3.92993931,1.91704471 L4.69634921,1.91704471 C4.94649939,1.91704471 5.07797261,1.61787814 4.90706821,1.43381803 Z",
    transform: "rotate(90 3.0713815689086914,3.0613412857055664) "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelUpAlt90);
export default __webpack_public_path__ + "static/media/level-up-alt-90.ed4f3ecd259d69910dc8b7420f53a94c.svg";
export { ForwardRef as ReactComponent };